<template>
  <div class="fixed bottom-0 left-0 w-full h-8 bg-gray-700 overflow-hidden shadow-[0_-1px_6px_rgba(0,0,0,0.35)]">
    <ConfettiExplosion v-if="showConfetti" :particleCount="200" :force="0.3" :colors="['#2dd4bf', '#4ade80', '#1a1a1a']" />
    <div
        class="bg-gradient-to-r from-green-400 to-teal-400 h-full absolute top-0 left-0 transition-[width] duration-700 ease-out"
        :style="{ width: `${progressPercentage}%` }"
    ></div>
    <div class="absolute inset-0 grid grid-cols-3 items-center px-2 text-xs text-white">
      <span class="text-left text-white/80 drop-shadow-[0_1px_1px_rgba(0,0,0,0.5)]">Lvl {{ currentLevel }}</span>
      <span
          class="text-center font-bold drop-shadow-[0_1px_2px_rgba(0,0,0,0.6)]"
          :class="{'pop-animation': isPopping}">{{ displayXp }} / {{ nextLevelXp }} XP</span>
      <span class="text-right text-white/80 drop-shadow-[0_1px_1px_rgba(0,0,0,0.5)]">Lvl {{ nextLevel }}</span>
    </div>
  </div>
</template>

<script setup>

import ConfettiExplosion from "vue-confetti-explosion";
import {computed, ref, watch} from "vue";
import {useLevels} from "../composables/useLevels.js";
import {useCountUp} from "../composables/useCountUp.js";

const props = defineProps({
  xp: Number,
  isPopping: Boolean
});

const { calculateCurrentLevel, calculateNextLevelXp } = useLevels();
const levelConstant = 50;

const showConfetti = ref(false);

const xp = computed(() => props.xp);

// Tween only the displayed figure; the bar width and level boundaries stay on the real xp
// so the number ticks up while the bar slides to the true fill.
const displayXp = useCountUp(() => props.xp);

const nextLevel = computed(() => currentLevel.value + 1);
const currentLevel = computed(() => {
  return calculateCurrentLevel(xp.value);
});

const nextLevelXp = computed(() => {
  return calculateNextLevelXp(xp.value, currentLevel.value);
});

watch(currentLevel, (after, before) => {
  if (before >= 1 && after !== before) {
    showConfetti.value = true
    setTimeout(() => showConfetti.value = false,3000);
  }
});

const progressPercentage = computed(() => {
  const currentLevelXp = nextLevelXp.value - levelConstant * currentLevel.value ** 1.2;
  const xpProgress = xp.value - currentLevelXp; // XP gained within this level
  const xpForNext = nextLevelXp.value - currentLevelXp; // Total XP needed for this level
  return Math.min((xpProgress / xpForNext) * 100, 100); // Calculate percentage and cap at 100%
});</script>


<style scoped>

something {
  color: #2dd4bf;
  color: #4ade80;
  color: #1a1a1a;
}
</style>